export abstract class AbstractNavigationService {
  abstract goToHome(): void;

  abstract goToGoogleAuthSetup(): void;

  abstract goToEnableTwoFactorAuth(): void;

  abstract goToChooseAuthMethod(): void;

  abstract goToTwoFactorOptions(): void;

  abstract goToVerifyGoogleAuth(): void;

  abstract goToVerifyBackupCode(): void;

  abstract goToBackupCodes(): void;
}
